import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from './assets/logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "center footer" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://vets-index.com",
    class: "vetsindex",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "© Vets Index"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "Vets Index"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_n_dialog_provider = _resolveComponent("n-dialog-provider")!

  return (_openBlock(), _createBlock(_component_n_dialog_provider, null, {
    default: _withCtx(() => [
      _createVNode(_component_router_view),
      _hoisted_1
    ]),
    _: 1
  }))
}